export function isExistingBusiness() {
  return String(sessionStorage.getItem("dealConfirmed")) === "true";
}
export function isLostCheck() {
  return String(sessionStorage.getItem("isLost")) === "true";
}
export function hasNewAddition(location) {
  if (location.isNewAddition) return true;
  // Nested classCodesInfo check
  if (location.classCodesInfo) {
    return Object.values(location.classCodesInfo).some(
      (cls) => cls.isNewAddition == true,
    );
  }
  return false;
}

export function hasMoreThanOneNewAdditions(location) {
  if (location.isNewAddition) return true;
  // Nested classCodesInfo check
  if (location.classCodesInfo) {
    const newlyAddedCcs = Object.values(location.classCodesInfo).filter(
      (cls) => cls.isNewAddition === true,
    );
    return newlyAddedCcs.length > 1;
  }
  return false;
}

export function isdealConfirmedAndHasNewAddition(props) {
  const dealConfirmed = isExistingBusiness();
  const { childrenLoc, officersList } = props;

  // Check if any isNewAddition flag is true in locations / class codes
  const hasNewAdditions = Object.values(childrenLoc || {}).some((loc) => {
    return hasNewAddition(loc);
  });

  // Check if any officer has isNewOfficerAddition flag
  const hasNewOfficerAddition = (officersList || []).some(
    (off) => off?.isNewOfficerAddition === true
  );

  if (dealConfirmed && !hasNewAdditions && !hasNewOfficerAddition) {
    return true; // disable
  }

  return false; // enable in all other cases
}
